export default __webpack_public_path__ + "static/media/hwr-masthead-1.195fe5f8.png";